import { render, staticRenderFns } from "./devServiceProvideList.vue?vue&type=template&id=701a833a&scoped=true"
import script from "./devServiceProvideList.vue?vue&type=script&lang=js"
export * from "./devServiceProvideList.vue?vue&type=script&lang=js"
import style0 from "./devServiceProvideList.vue?vue&type=style&index=0&id=701a833a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a833a",
  null
  
)

export default component.exports